module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="hotel-introduction" class="hdi-brief-item-content" data-content="' +
((__t = ( o )) == null ? '' : __t) +
'" style="margin-bottom: 10px;">\r\n    ';
 if(o && o.length > 45){ ;
__p += '\r\n        <span>' +
((__t = ( o.substring(0,45) )) == null ? '' : __t) +
'......</span>\r\n        <a href="javascipt:void(0);" class="hdi-brief-view-detail">[查看详情]</a>\r\n    ';
 } else { ;
__p += '\r\n        <span>' +
((__t = ( o || '' )) == null ? '' : __t) +
'</span>\r\n    ';
 } ;
__p += '\r\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/hotelPriceUtil/templates/hotelIntroductionTmpl.ejs
// module id = 159
// module chunks = 3 6